import {CODELOGIC_UI_PATH} from 'src/config';

const IMAGE_BASE_PATH = CODELOGIC_UI_PATH + '/administration/agents';

export const AgentImage = ({alt, url}: {alt: string, url: string}) =>
  <img className="AgentImage" alt={alt} src={IMAGE_BASE_PATH + '/' + url} />;
